var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMostPlayed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.464,
    cy: 49.464,
    r: 49.464,
    fill: "#01A0C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8604 29.3692L70.5466 37.0555L54.2029 53.3825L40.8064 39.986L15.9727 64.8197L20.7117 69.5587L40.8064 49.464L54.2029 62.8605L75.2689 41.7777L82.9551 49.464V29.3692H62.8604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostPlayed);
export default __webpack_public_path__ + "static/media/most-played.4959e151.svg";
export { ForwardRef as ReactComponent };